import { Route } from '@angular/router';
import { RoutePath } from '@univacity/shared/types';
import { TourBookingResolver } from './resolvers/tour-booking.resolver';
import { TourResolver } from './resolvers/tour.resolver';

export const tourRoutes: Route[] = [
  {
    path: '',
    pathMatch: 'full',
    redirectTo: 'search',
  },
  {
    path: RoutePath.search,
    loadComponent: () =>
      import('./search-page/tour-search-page/tour-search-page.component').then(
        (m) => m.TourSearchPageComponent
      ),
  },
  {
    path: `${RoutePath.bookings}`,
    resolve: {
      booking: TourBookingResolver,
    },
    loadComponent: () =>
      import(
        './tour-booking-detail-page/tour-booking-detail-page.component'
      ).then((m) => m.TourBookingDetailPageComponent),
  },
  {
    path: ':id',
    resolve: {
      tour: TourResolver,
    },
    loadComponent: () =>
      import('./detail-page/tour-detail-page/tour-detail-page.component').then(
        (m) => m.TourDetailPageComponent
      ),
  },
  {
    path: `:id/${RoutePath.checkout}`,
    resolve: {
      tour: TourResolver,
    },
    loadComponent: () =>
      import(
        './tour-checkout/tour-checkout-page/tour-checkout-page.component'
      ).then((m) => m.TourCheckoutPageComponent),
  },
];
